import api from '../services/api';
import { $Q, $Qll } from '../utils/querySelector';
import { Cart } from './cart';
import { History } from './pageHistory';

class Search {
  constructor() {
    this.categories = ['product', 'page', 'article'];
    this.history = new History();
    this.totalResults = 0;
  }

  /**
   * Initialize search with a loop for each category
   */
  async _init() {
    this.categories.forEach((category) => {
      const url = window.location.href.split('?')[0];
      const query = this.getQueryParam(null, 'q');
      this.fetchByCategory({ url, query, category });
    });

    return this.totalResults;
  }

  /**
   * It fetchs category info based on params
   * @param {Object} _params : This contains category info to use shopify fetch
   * @param {String} _params.url : This is the base url
   * @param {String} _params.query : This is the query to be searched
   * @param {String} _params.category : This is the category to be fetched
   * @param {Number} _params.page : The number of the page to be fetched
   */
  async fetchByCategory(_params) {
    const { url, query, category, page = '' } = _params;
    const params = {
      q: query,
      type: category,
      page: page || 1,
    };

    const response = await api.shopifyByUrlAndParams(url, params);
    const resultsDOM = new DOMParser().parseFromString(
      response.data,
      'text/html'
    );

    this.renderResults(resultsDOM, category);
  }

  /**
   * It gets the query param to be searched
   * @param {String} url : It is the base url
   * @param {String} _query : It is the query word to be searched
   * @returns
   */
  getQueryParam(url = '', _query) {
    const href = url || window.location.href;
    const query = href.split('?')[1];

    if (!query) return;
    const queryParam = query.split(`${_query}=`)[1].split('&')[0];

    return queryParam;
  }

  /**
   * It renders the fetched results in the DOM
   * @param {Document} results : It is body fetched
   * @param {String} category : It is the category of results
   */
  renderResults(results, category) {
    /* Fetched results container */
    const resultsContainer = $Q('#result-list', results);
    /* In DOM category container */
    const categoryContainer = $Q(`#${category}s-list`);
    /* Total results per category */
    const categoryTotal = this.sumCategoryTotal(resultsContainer);
    /* Render total results for all categorries */
    this.renderTotalResults();
    /* Stop rendering if total quantity is zero or falsy */
    if (!categoryTotal) return;

    const titleInfo = $Q('.results-container__info .results-container__query', results);
    if (!titleInfo) return;

    const input = $Q('.search-results__input');
    const value = input.value;
    titleInfo.innerText = `"${value}"`;

    const firstCategory = this.history.pageTypes.find((item) =>
      this.history.prev.includes(item)
    );

    const firstElement = $Q(
      `#${firstCategory === 'blog' ? 'article' : 'product'}s-list`
    );

    const secondElement = $Q(
      `#${firstCategory !== 'blog' && 'collection'}s-list`
    );

    firstElement?.classList?.add('order--first');
    secondElement?.classList?.add('order--first');

    if (resultsContainer.innerHTML) {
      categoryContainer.innerHTML = resultsContainer.innerHTML;
    }

    setTimeout(() => {
      this.readPaginationClick();

      if (category === 'product') {
        const cart = new Cart();
        cart.addToCart();
        window.backInStockRegisterEvents();
        window.zooomyColl();
      }
    }, 0);

    return this.totalResults;
  }

  /**
   * It get the category total and sums it to total results
   * @param {HTMLElement} parent : it its the parent for results
   */
  sumCategoryTotal(parent, partial) {
    if (parent) {
      const container = $Q('.results-container', parent);
      const total = container.dataset.total;
      this.totalResults += parseInt(total);
      return typeof total === 'string' ? parseInt(total) : total;
    } else if (partial) {
      this.totalResults += parseInt(partial);
      return typeof partial === 'string' ? parseInt(partial) : partial;
    }
  }

  /**
   * Render total results on DOM
   */
  renderTotalResults() {
    const totalText = $Q('.search-results__total #quantity');
    totalText.dataset.quantity = this.totalResults;
    totalText.innerHTML = this.totalResults;
  }

  /**
   * It reads the click on pagination buttons
   */
  readPaginationClick() {
    const paginationLinks = $Qll(
      '.results-container .pagination .pagination--nav li a'
    );

    paginationLinks.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        const href = button.getAttribute('href');
        const hrefSplitted = href.split('?')[0];
        const page = this.getQueryParam(href, 'page');
        const query = this.getQueryParam(null, 'q');
        const parent = button.closest('.list-container');

        const category = this.categories.find(
          (category) =>
            $Q(`#${category}s-list`).getAttribute('id') ===
            parent.getAttribute('id')
        );

        this.fetchByCategory({ url: hrefSplitted, query, category, page });
      });
    });
  }
}

export { Search };
